// extracted by mini-css-extract-plugin
export default {"list":"data-list_list__+SmwX","show":"data-list_show__N0nij","item":"data-list_item__FMEoX","active":"data-list_active__vhFXm","empty":"data-list_empty__ZjlOB"};